import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { AmenitiesModal } from './AmenitiesModal';

export const InfoOffers = ({ amenities }) => {
  const t = useTranslations();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {amenities.length !== 0 && (
        <div className="flex flex-col gap-6 border-t border-slate-300 pt-8 pb-10 lg:pr-8">
          <h4 className="text-slate-700 text-lg font-semibold tracking-tight">
            {t('apartment.amenities.title')}
          </h4>

          <ul className="grid sm:grid-cols-2 gap-y-6 gap-x-[46px]">
            {amenities?.slice(0, 8).map((amenity, i) => (
              <li
                key={i}
                className="col-span-1 gap-y-3 inline-flex items-center"
              >
                {amenity.iconName && (
                  <i
                    className={`inline-flex justify-center items-center text-primary-800 self-start text-[24px] icon-mr icon-${amenity.iconName}`}
                  />
                )}
                <span className="text-slate-500 text-base self-start pt-0.5">
                  {amenity.name}
                </span>
              </li>
            ))}
          </ul>

          {amenities.length > 8 && (
            <button
              onClick={() => setIsOpen(true)}
              className="btn btn-second self-start"
              type="button"
              data-testid="room-amenities-show-more-button"
            >
              <span>
                {t('show-all')} {amenities?.length}{' '}
                <span className="lowercase">{t('amenities')}</span>
              </span>
            </button>
          )}

          <AmenitiesModal
            show={isOpen}
            close={() => setIsOpen(false)}
            amenities={amenities}
          />
        </div>
      )}
    </>
  );
};
